export interface Requirement {
    name: string;
    status: string;
    message: string;
    code: string;
}

export interface BvnNinName {
    firstName: string;
    middleName: string;
    lastName: string;
}

export interface Match {
    ninName?: BvnNinName;
    bvnName?: BvnNinName;
    match: boolean;
    message: string;
    code: number;
    ninDob?: string;
    bvnDob?: string | null;
    ninPhoneNumber?: string;
    bvnPhoneNumber?: string;
    issues?: Array<any>;
}

export interface BvnNinMatch {
    status: string;
    code: number;
    nameMatch: Match;
    dobMatch: Match;
    phoneNumberMatch: Match;
    bvnNumber: string;
    ninNumber: string;
}

export interface KycBvnNinMistmatchV2 {
    pendingKycVerificationId: number;
    kycLevelTwoStatus: string;
    requirements: Requirement[];
    bvnNinMatch: BvnNinMatch;
    mergeFlow?: MergeFlow;
}

export interface Field {
    label: string;
    value: string | null;
    compareValue: string | null;
}

export interface BvnNinMismatchData {
    bvnNumber: string;
    ninNumber: string;
    data: TransformedData[];
}

export interface TransformedData {
    label: string;
    match: boolean;
    ninFields: Field[];
    bvnFields: Field[];
    issues: Array<{ label: string; message: string }>;
}

export const enum OwnerType {
    BO = 'BO',
    BRM = 'BRM',
    BANNER = 'BANNER',
}

export interface Profile {
    nubanAccountNumber: string;
    businessName: string;
    domain: string;
    accountBalance: number;
    phoneNumber: string;
    email: string;
    username: string;
    numberOfOtherAccounts: number;
    profileImage: string;
    passcodeEnabled: boolean;
    preferred: boolean;
}

export interface ProfileInfo {
    currentProfile: Profile;
    duplicateProfile: Profile;
    allowSelection: boolean;
}

export interface MergeFlow {
    data?: ProfileInfo;
    profileInfo: ProfileInfo;
    metadata: {
        domain: string;
        maskedBvnNumber: string;
        customerFirstName: string;
    };
}

export interface BvnNinHardFetchOptions {
    bvn: string;
    nin: string;
    shouldHardFetch: boolean;
    identityType: string;
}

export const PREFFERED_KYC_STORAGE_ID_FOR_MERGE_FLOW = 'preferredKycId';
